import { useEffect } from "react";
import { Button } from "../../components";
import { useLoanCalculator } from "../../contexts";
import { useDpConfig } from "../../contexts/dpConfig";
import { LoanCalculatorFactory } from "./Products";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  className?: string;
  actionButton?: string;
  onAction?: () => void;
};

const LoanCalculatorModal: React.FC<Props> = ({
  isOpen,
  onClose,
  className,
  actionButton,
  onAction,
}) => {
  const {
    state: { type },
  } = useLoanCalculator();

  const {
    state: { products, settings },
  } = useDpConfig();

  return isOpen ? (
    <>
      <div className="cx-fixed cx-inset-0 cx-bg-background-overlay-primary cx-z-40"></div>
      <div className="cx-fixed cx-z-50 cx-inset-0 cx-overflow-y-auto">
        <div className="cx-flex cx-items-center cx-justify-center cx-min-h-screen">
          <div
            className="cx-fixed cx-inset-0 cx-bg-gray-500 cx-opacity-90"
            onClick={onClose}
          ></div>
          <div
            className={`cx-relative cx-bg-background-default cx-rounded-modal cx-max-w-[960px] ${className}`}
          >
            <LoanCalculatorFactory
              product={type!}
              editMode
              handleSubmit={onAction}
              handleCancel={onClose}
              tags={products.find((p) => p.type === type)?.config?.tags}
              message={settings?.loanCalculatorMessage}
            />
            {!!actionButton && (
              <div className="cx-flex cx-items-center cx-justify-center cx-w-full">
                <div className="cx-max-w-[400px] cx-w-full">
                  <Button label={actionButton} onClick={onAction} fullWidth />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  ) : null;
};

export default LoanCalculatorModal;
